import React, { useEffect, useState, useRef, useCallback } from 'react'
import { FormattedDate, FormattedTime, useIntl } from 'react-intl'
import { selectUnit } from '@formatjs/intl-utils'
import templates from './templates'
import { Button } from '@arnsbogroup/react-voicearchive'

const Chat = ({ supplier }) => {
  const threadRef = useRef(null)
  const messageRef = useRef(null)
  const [message, setMessage] = useState('')
  const [messages, setMessages] = useState([])

  useEffect(() => {
    fetch(`/message/getSupplierMessages?supplierId=${supplier.uid}`)
      .then((response) => response.json())
      .then((messages) => setMessages(messages))
      .then(() => {
        if (threadRef.current) {
          threadRef.current.scrollTop = threadRef.current.scrollHeight
        }
      })
      .catch((error) => window.alert(error))
  }, [supplier.uid])

  const onSend = useCallback(() => {
    if (!message.length) {
      return window.alert('Message is empty!')
    }

    const subject = `${supplier.firstname}, you got mail!`
    const msg = encodeURIComponent(message)

    setMessage('')
    
    fetch(`/message/sendDirectSupplierMessage?supplierId=${supplier.uid}&subject=${subject}&msg=${msg}`)
      .then((response) => response.json())
      .then((nextMessage) => setMessages([...messages, nextMessage]))
      .then(() => {
        if (threadRef.current) {
          threadRef.current.scrollTop = threadRef.current.scrollHeight
        }
      })
      .catch((error) => window.alert(error))
  }, [message])


  return (
    <div className="w-full h-full flex flex-col">
      <div className="grow overflow-y-scroll p-4 space-y-4" ref={threadRef}>
        { messages.map(({ uid, crdate, subject, msg }) => {
          return (
            <div key={uid} className="w-auto">
              <p
                tabIndex="0"
                className="shadow-sm cursor-pointer max-h-48 focus:max-h-full focus:outline-none focus:ring focus:border-primary-darker break-words overflow-hidden rounded bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 text-sm"
              >
                { msg }
              </p>
              <div className="text-xs mt-1 w-full text-right px-1 text-gray-500">
                <FormattedDate value={new Date(crdate * 1000)} /> <FormattedTime value={new Date(crdate * 1000)} />
              </div>
            </div>
          )
        }) }
      </div>

      <div className="p-4">

        <div className="grid grid-cols-2 grid-rows-2 gap-1 text-sm text-primary py-1">
          { Object.entries(templates).map(([name, func]) => (
            <Button
              size='xs'
              onClick={(event) => {
                event.stopPropagation()
                event.preventDefault()
                setMessage(func(supplier))
                if (messageRef) {
                  messageRef.current.focus()
                }
              }}
            >
              { name }
            </Button>
          )) }
        </div>

        <textarea
          ref={messageRef}
          className="px-4 py-2 rounded-sm text-sm border border-gray-400 w-full"
          value={message}
          onFocus={() => messageRef.current.classList.add('h-40')}
          onBlur={() => messageRef.current && messageRef.current.classList.remove('h-40')}
          onChange={({ target: { value } }) => setMessage(value)}
          placeholder="Start typing.."
        />
        
        <div className='text-right'>
          <Button
            variant={message.length ? 'solid' : 'outline'}
            size='sm'
            disabled={!message.length}
            onClick={onSend}
          >
            Send
          </Button>
        </div>
      </div>
    </div>
  )
}

export default Chat
